// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import LaborRateRequest from './labor-rate-request';
import LaborRateRequestCount from '@deere/cps-it.warranty-model-factory/lib/labor-rate-request-count';

const LaborRateRequestTypeCount = props =>
    <div>
        <LaborRateRequest
            className=''
            count={props.laborRateRequestCount.newCount}
            status='SUBMITTED'
            statusKey='01'
        />
        <LaborRateRequest
            className=''
            count={props.laborRateRequestCount.acceptedCount}
            status='APPROVED'
            statusKey='02'
        />
        <LaborRateRequest
            className=''
            count={props.laborRateRequestCount.rejectedCount}
            status='REJECTED'
            statusKey='03'
        />
        <LaborRateRequest
            className=''
            count={props.laborRateRequestCount.returnedCount}
            status='RETURNED'
            statusKey='04'
        />
    </div>;

LaborRateRequestTypeCount.displayName = 'LaborRateRequestTypeCount';
LaborRateRequestTypeCount.propTypes = {
    laborRateRequestCount: PropTypes.instanceOf(LaborRateRequestCount).isRequired
};

export default LaborRateRequestTypeCount;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/components/labor-rate-request-count.js